import { useEffect } from "react";

const DEFAULT_SAFECRM_BASE = "https://safefind.com.br";
const WEBCHAT_SCRIPT_ID = "safecrm-safelife-webchat";

export default function SafeCrmWebchat() {
  useEffect(() => {
    if (typeof document === "undefined") return;

    const apiBase = (
      process.env.REACT_APP_SAFECRM_WEBCHAT_BASE ||
      DEFAULT_SAFECRM_BASE
    ).replace(/\/+$/, "");

    const existingScript = document.getElementById(WEBCHAT_SCRIPT_ID);
    if (existingScript) return;

    const script = document.createElement("script");
    script.id = WEBCHAT_SCRIPT_ID;
    script.src = `${apiBase}/api/public/webchat/safelife-widget.js`;
    script.async = true;
    script.dataset.siteKey = "safelife";
    script.dataset.apiBase = apiBase;

    document.body.appendChild(script);
  }, []);

  return null;
}
